module.exports = __webpack_public_path__ + "static/media/04_workshop_video.32223a8c.png";